export default "__VITE_ASSET__CoOvfBdr__"